import React, { useState } from 'react';
import './styles.scss';
import { Button, Input } from '@cokitchen/cokitchen-components';
import { useNavigate } from 'react-router-dom';
import { ENUM_SEARCH_KEY } from 'utils/enum';

const Search = () => {
  const navigate = useNavigate();
  const [filterValue, setFilterValue] = useState('' as ENUM_SEARCH_KEY);
  const [searchFilter, setSearchFilter] = useState<string>('');

  const options = [
    { label: 'Full name', value: ENUM_SEARCH_KEY.FULL_NAME },
    { label: 'Email', value: ENUM_SEARCH_KEY.EMAIL },
    { label: 'Username', value: ENUM_SEARCH_KEY.NAME },
    { label: 'Order Number', value: ENUM_SEARCH_KEY.ORDER_CODE },
    { label: 'Rider Name', value: ENUM_SEARCH_KEY.RIDER_NAME },
    { label: 'Phone Number', value: ENUM_SEARCH_KEY.PHONE_NUMBER }
  ];

  const searchFunc = async () => {
    navigate(`/search-result/${filterValue}/${searchFilter}`);
  };

  return (
    <div>
      <div className='search h-[60vh] grid md:place-content-center'>
        <div className='max-w-[800px] space-y-4'>
          <div className='w-full flex flex-col md:flex-row gap-2 md:gap-0 items-center relative mx-auto'>
            <Input
              type='search'
              placeholder='Type in anything'
              className='search-input'
              small
              onChange={(e: any) => setSearchFilter(e.target.value)}
              name='searchFilter'
              value={searchFilter}
            />
            <Button
              variant='block'
              color='primary'
              small
              className='search-btn'
              disabled={!filterValue || !searchFilter}
              onClick={searchFunc}>
              Search
            </Button>
          </div>

          <p className='text-xs text-gray-5 text-center md:text-left'>
            Filter your search by searching with:
          </p>
          <div className='pt-2 flex justify-center flex-wrap gap-y-6 items-start w-full'>
            {options.map(({ value, label }, i) => (
              <Input
                key={i}
                value={value}
                label={label}
                inputClass=''
                type='radio'
                name='search-filter'
                className='pr-7'
                onChange={() => setFilterValue(value)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Search;
